import { useMemo } from "react";
import { useIsMobile } from "../hooks/useIsMobile";

export default function AgentProfileModal({ clients, logEntries, onClose }) {
  const isMobile = useIsMobile();

  const openTasksCount = useMemo(() =>
    logEntries.filter(e => e.type === "task" && !e.done).length,
    [logEntries]);

  const pendingFeesTotal = useMemo(() =>
    logEntries
      .filter(e => e.type === "fee" && !e.feeCollected)
      .reduce((s, e) => s + (Number(e.amount) || 0), 0),
    [logEntries]);

  const collectedThisMonth = useMemo(() => {
    const month = new Date().toISOString().slice(0, 7);
    return logEntries
      .filter(e => e.type === "fee" && e.feeCollected && e.date?.startsWith(month))
      .reduce((s, e) => s + (Number(e.amount) || 0), 0);
  }, [logEntries]);

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 5000,
        background: "rgba(15,23,42,0.5)", backdropFilter: "blur(2px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        direction: "rtl", padding: 16,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: "white", borderRadius: 16,
          width: "100%", maxWidth: 560, maxHeight: "90vh", overflowY: "auto",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          display: "flex", flexDirection: "column",
        }}
      >
        <div style={{
          background: "linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)",
          padding: "18px 24px", color: "white",
          display: "flex", justifyContent: "space-between", alignItems: "center",
          borderRadius: "16px 16px 0 0",
        }}>
          <div style={{ fontSize: 18, fontWeight: 800 }}>👤 פרטי סוכן</div>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", color: "white", fontSize: 22, cursor: "pointer" }}
          >×</button>
        </div>

        <div style={{
          padding: isMobile ? 16 : 24,
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: 12,
        }}>
          <KpiCard icon="👥" label="לקוחות" value={clients.length} color="#4338ca" />
          <KpiCard icon="🔔" label="משימות פתוחות" value={openTasksCount} color="#dc2626" />
          <KpiCard
            icon="💰" label="עמלות לגביה"
            value={pendingFeesTotal > 0 ? `₪${pendingFeesTotal.toLocaleString("he-IL")}` : "—"}
            color="#d97706"
          />
          <KpiCard
            icon="✅" label="נגבו החודש"
            value={collectedThisMonth > 0 ? `₪${collectedThisMonth.toLocaleString("he-IL")}` : "—"}
            color="#059669"
          />
        </div>
      </div>
    </div>
  );
}

function KpiCard({ icon, label, value, color }) {
  return (
    <div style={{
      background: "white", borderRadius: 10, padding: "14px 18px",
      border: `1px solid ${color}30`,
      display: "flex", flexDirection: "column", gap: 4,
    }}>
      <div style={{ fontSize: 12, color: "#64748b", textAlign: "right" }}>{icon} {label}</div>
      <div style={{ fontSize: 22, fontWeight: 800, color, textAlign: "right" }}>{value}</div>
    </div>
  );
}
